/**
 * Lyra Therapy (LT) Coaching role configurations.
 */

import { COACH_CALENDAR, MINIMAL_CALENDAR } from './calendars'
import { RoleConfig } from './types'

/**
 * LT Coach configuration.
 * Used by: LT_COACH, LT_NSC_COACH, LT_CGT_COACH, LT_MANAGER_COACH
 * Extended by: LT_CFP_COACH
 */
export const LT_COACH: RoleConfig = {
  sameDayBooking: true,
  bcPlatform: true,
  showOOOMessageTab: true,
  videoSessionsEnabled: true,
  medicationEnabled: false,
  zendeskWidget: false,
  requestPayment: false,
  directAccessClientList: false,
  helpCenterUrl: 'https://coaching-lyrahealth.zendesk.com/hc/en-us',
  eligibilityChecker: false,
  utilizationEnabled: true,
  showMinifiedUtilization: true,
  showOverdueMessageFlag: true,
  showInPersonPrompt: false,
  smartSchedulingEnabled: false,
  hidePerformanceMetrics: false,
  showCloseSessionBanner: true,
  inProductCalendar: COACH_CALENDAR,
  showCareInsights: false,
}

/**
 * LT Single Session Coach configuration.
 * Note: Original config was sparse - missing bcPlatform and other BC properties.
 */
export const LT_SS_COACH: RoleConfig = {
  sameDayBooking: true,
  eligibilityChecker: false,
  directAccessClientList: false,
  showInPersonPrompt: false,
  smartSchedulingEnabled: false,
  hidePerformanceMetrics: false,
  showCloseSessionBanner: true,
  inProductCalendar: COACH_CALENDAR,
  showCareInsights: false,
}

/**
 * LT CFP Coach configuration.
 * Extends LT Coach with assessment track settings access.
 * Used by: LT_CFP_COACH
 */
export const LT_CFP_COACH: RoleConfig = {
  ...LT_COACH,
  assessmentTrackSettingsEnabled: true,
}

/**
 * LT Coach Supervisor configuration.
 * Used by: LT_COACH_SUPERVISOR, LT_SS_COACH_SUPERVISOR, LT_NSC_COACH_SUPERVISOR
 */
export const LT_COACH_SUPERVISOR: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: false,
  assessmentTrackSettingsEnabled: true,
  inProductCalendar: MINIMAL_CALENDAR,
}
